const Strings = {
  SEND_RESET_MAIL: {
    SE: 'Skicka återsällningsmail',
    EN: 'Send reset mail'
  },
  EMAIL: {
    SE: 'Email',
    EN: 'Email'
  },
  RESET_PASSWORD: {
    SE: 'Återställ lösenord',
    EN: 'Reset password'
  },
  BACK_TO_LOGIN: {
    SE: 'Tillbaks till inloggning',
    EN: 'Back to login'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/ForgotPassword/strings.js